export const module = {
  info: {
    name: 'voip-broadcast',
    caption: 'Voip Broadcast',
    viewGroup: 'servers-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    topSeparator: false,
    caption: 'Broadcast',
    icon: 'el-icon-folder',
    routeName: 'module->voip-broadcast->panel',
    /*children: [
      {
        caption: 'Create Customer',
        icon: 'el-icon-plus',
        routeName: 'module->jikatel-customer->create'
      },
      {
        caption: 'List Customers',
        icon: 'el-icon-more-outline',
        routeName: 'module->jikatel-customer->list'
      }
    ]*/
  }
}

export default module
